import React, { useState } from "react";

const ChatListFooter = ({ onDone }) => {
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  const handleDone = async () => {
    setIsSubmitLoading(true);
    await onDone();
    setIsSubmitLoading(false);
  };
  return (
    <div className="w-full max-w-md top-0 bottom-0 sticky">
      <button
        className="btn btn-default bg-[var(--primary-color)] text-white w-full h-12 font-normal rounded-full border-0"
        onClick={handleDone}
        disabled={isSubmitLoading}
      >
        {isSubmitLoading ? "Loading..." : "Done"}
      </button>
    </div>
  );
};

export default ChatListFooter;
